<template>
  <div>
    <div
      v-for="(item) in list"
      :key="item.name"
      @click="handleClickAction(item)"
    >
      <Count
        :class="$style.listItem"
        :count="parseInt(item.value)"
        countSize="extraSmall"
        :hasDivider="false"
        :label="item.name"
      />
    </div>
  </div>
</template>

<script>

import {
  Count,
} from '@jumpcloud/ui-components';

export default {
  name: 'WidgetList',

  components: {
    Count,
  },

  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
    };
  },

  methods: {
    handleClickAction(item) {
      this.$emit('handleClickAction', item);
    },
  },

};
</script>

<style scoped module>
.listItem {
  color: var(--jc-color-informational-strong) !important;
  cursor: pointer;
  line-height: 1rem;
  padding: var(--jc-spacer-small) 0;
}
</style>
